import {Avatar} from '@mui/material';
import grey from '@mui/material/colors/grey.js';
import {node, number, object} from 'prop-types';
import React from 'react';

const AppLogo = ({backgroundColor = grey, size = 26, icon}) => {
  const Icon = React.cloneElement(icon, {
    fontSize: 'inherit',
  });
  return (
    <Avatar
      sx={{
        borderRadius: 1,
        width: size,
        height: size,
        backgroundColor: backgroundColor[600],
        border: `1px solid ${backgroundColor[700]}`,
        color: theme => theme.palette.getContrastText(backgroundColor[600]),
        // make icon proportional to the avatar size
        fontSize: size / 1.35,
      }}
    >
      {Icon}
    </Avatar>
  );
};

AppLogo.propTypes = {
  backgroundColor: object,
  size: number,
  icon: node.isRequired,
};

export default AppLogo;
